<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'article/index' }">
                                Berita
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'article/view', params: {id: article.id} }">
                                {{ article.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Edit
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Edit Berita
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium">Upload Banner Berita</label>
                                <input id="image" type="file" class="form-control" v-on:change="preview" placeholder="Choose File" accept="image/*"/>
                                <label for="image" class="form-control form-control-sm">
                                    <button type="button" class="btn btn-danger btn-sm font-weight-bold">
                                        Choose File
                                    </button> 
                                </label>
                                <img v-bind:src="imagePreview" class="img-fluid mt-2 w-100" />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium">Tanggal Berita</label>
                                <label class="h4 font-weight-bold d-block">{{ [article.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("dddd, D MMMM YYYY") }}</label>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Judul Berita</label>
                                <input v-model="form.title" class="form-control form-control-sm" placeholder="Judul" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium">Kalimat Pembuka</label>
                                <input v-model="form.foreword" class="form-control form-control-sm" placeholder="Kalimat Pembuka" />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Isi Berita</label>
                                <tinymce id="text-editor" v-model="form.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'article/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import tinymce from 'vue-tinymce-editor';
    import { tinyMCEOptions } from '@/params.js';

    export default {
        name: "ArticleEdit",
        components: {
            tinymce
        },
        data() {
            return {
                form: {
                    title: '',
                    foreword: '',
                    content: '',
                    image: ''
                },
                article: {},
                imagePreview: '',
                tinyMCEOptions: tinyMCEOptions
            };
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var attribute in this.form) {
                    formData.set(attribute, this.form[attribute]);
                }
                this.axios.post(process.env.API_URL + '/article/update/' + this.article.id, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'article/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/article/' + this.$route.params.id).then(response => {
                this.article = response.data.data.current;

                this.form = Object.assign({}, this.article, {image: ''});

                this.imagePreview = this.article.imageUrl;

                document.title = 'Edit Berita - ' + this.article.title + ' - ' + process.env.APP_NAME;
            });
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/article/Edit.vue